import React, { useState } from 'react';
import { TextField, Container, Typography } from '@mui/material';
import LoadingButton from '@mui/lab/LoadingButton';

import FancyFileUploadButton from './components/FancyFileUploadButton';
import axios from 'axios';

function App() {
    const [field1, setField1] = useState('');
    const [field2, setField2] = useState('');
    const [field3, setField3] = useState('');
    const [field4, setField4] = useState('');
    const [file, setFile] = useState(null);
    const [isLoading,  setIsLoading] = useState(false);
    const handleUpload = () => {
        const formData = new FormData();
        formData.append('jsonFile', file);
        formData.append('field1', field1);
        formData.append('field2', field2);
        formData.append('field3', field3);
        formData.append('field4', field4);
        setIsLoading(true);
        axios.post('/generate-pdf', formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            },
            responseType: 'blob'  // Tell axios to expect a blob response (binary data)
        }).then(response => {
            setIsLoading(false);
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            // get current date and time as string, the format should be  YYYY-MM-DD-HH-mm-ss
            const dateTime = new Date().toISOString().slice(0, 19);
            link.setAttribute('download', 'postcard-' + dateTime + '.pdf');
            document.body.appendChild(link);
            link.click();
        }).catch(error => {
            setIsLoading(false);
            if (error.response) {
                // When status is 400, we expect a JSON error, but it's returned as a blob
                const reader = new FileReader();
                reader.onload = () => {
                    const errorMessage = JSON.parse(reader.result).error;
                    console.error('Error message:', errorMessage);
                    alert(`Failed to generate PDF: ${errorMessage}`);
                };
                reader.readAsText(error.response.data);  // Read the blob as text (JSON error)
            } else if (error.request) {
                // No response received
                console.error('No response received:', error.request);
                alert('No response received from the server. Please try again later.');
            } else {
                // Error setting up request
                console.error('Error setting up request:', error.message);
                alert('An error occurred while setting up the request. Please try again.');
            }
        });
    };

    return (
        <Container maxWidth="sm">
            <img src="/static/logo.png" width={"150px"} alt = "Logo" />
            <Typography marginTop="50px" variant="h4" gutterBottom>Generate PDF from JSON</Typography>
            <TextField 
                label="General Note" 
                value={field1} 
                onChange={(e) => setField1(e.target.value)} 
                fullWidth 
                margin="normal"
            />
            <TextField 
                label="Permit #" 
                value={field2} 
                onChange={(e) => setField2(e.target.value)} 
                fullWidth 
                margin="normal"
            />
            <TextField
              label="Business zip code"
              value={field3}
              onChange={(e) => setField3(e.target.value)}
              fullWidth
              margin="normal"
            />
            <TextField
              label="PO Box"
              value={field4}
              onChange={(e) => setField4(e.target.value)}
              fullWidth
              margin="normal"
            />
            <FancyFileUploadButton file={file} handleFileUpload={(e) => {
                const file = e.target.files[0];
                setFile(file);
              }}
            />

            <LoadingButton
                sx={{ marginTop: '20px' }}
                variant="contained" 
                onClick={handleUpload}
                disabled={isLoading}
                loading={isLoading}
            >
                Upload JSON & Generate PDF
            </LoadingButton>
        </Container>
    );
}

export default App;
